import styled from 'styled-components';
import { colorUsage, getSpacing, gradientText, typography } from 'stylesheet';
import { Close } from 'theme/icons';
var Title = styled.h1.withConfig({
  displayName: "InternalLinkDialogstyle__Title",
  componentId: "sc-3qkkjb-0"
})(["", " ", ""], typography.h1, gradientText);
var CloseButton = styled(Close).withConfig({
  displayName: "InternalLinkDialogstyle__CloseButton",
  componentId: "sc-3qkkjb-1"
})(["position:absolute;right:", ";cursor:pointer;& path{fill:", ";}"], getSpacing(3), colorUsage.textColor);
var Description = styled.p.withConfig({
  displayName: "InternalLinkDialogstyle__Description",
  componentId: "sc-3qkkjb-2"
})(["margin-top:", ";text-align:center;"], getSpacing(1));
var ButtonContainer = styled.div.withConfig({
  displayName: "InternalLinkDialogstyle__ButtonContainer",
  componentId: "sc-3qkkjb-3"
})(["margin-top:", ";"], getSpacing(2));
var FiltersContainer = styled.div.withConfig({
  displayName: "InternalLinkDialogstyle__FiltersContainer",
  componentId: "sc-3qkkjb-4"
})(["display:flex;margin:", " 0;"], getSpacing(2));
var SearchBoxWrapper = styled.div.withConfig({
  displayName: "InternalLinkDialogstyle__SearchBoxWrapper",
  componentId: "sc-3qkkjb-5"
})(["margin-right:", ";"], getSpacing(1));
export { ButtonContainer, CloseButton, Description, FiltersContainer, SearchBoxWrapper, Title };